// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__y87rL","colMin":"styles_colMin__wXRuN","colCheckbox":"styles_colCheckbox__13D_k"};